<template>
  <div class="flex flex-col" :class="[{ 'lg:flex-row': isHorizontal }]">
    <div
      class="relative w-full overflow-hidden rounded bg-gray-lightest"
      :class="[
        { 'animate-pulse': loading },
        {
          'h-[210px] lg:h-[326px] lg:w-1/2': isHorizontal,
          'h-[210px]': isVertical,
        },
      ]"
    >
      <NuxtImg
        v-if="image"
        class="absolute inset-0 top-0 right-0 object-cover w-full h-full"
        :src="image.src"
        :alt="image.alt"
        width="373"
        height="210"
        sizes="sm:520 md:373"
        format="webp"
        loading="lazy"
        role="presentation"
      />
      <div
        v-if="showGradient && hasCaption"
        class="absolute inset-0 top-0 right-0 w-full h-full bg-gradient-to-t from-black/75 to-transparent"
        :class="[{ 'lg:hidden': isHorizontal }]"
      ></div>
      <p
        v-if="hasCaption"
        :class="[
          'absolute font-bold text-white bottom-4 left-4 right-4',
          {
            'lg:hidden': isHorizontal,
            'text-xl': captionSize === 'small',
            'text-2xl': captionSize === 'medium',
            'text-3xl': captionSize === 'large',
          },
        ]"
      >
        {{ caption }}
      </p>
    </div>
    <div
      class="flex flex-col p-4"
      :class="[
        {
          'w-full h-[326px] lg:w-1/2 lg:pl-16': isHorizontal,
        },
      ]"
    >
      <div
        v-if="loading"
        class="bg-gray-lightest h-[22px] animate-pulse mb-8"
      ></div>
      <NuxtLink
        v-if="hasTitle"
        :to="link"
        class="mb-8 font-bold text-section-headline"
      >
        {{ title }}
      </NuxtLink>
      <p
        v-if="hasCaption && isHorizontal"
        class="hidden mb-8 text-lg font-bold lg:block"
      >
        {{ caption }}
      </p>
      <div v-if="hasSlot('content')" :class="['mb-8']">
        <slot name="content"></slot>
      </div>
      <div v-if="hasSlot('footer')" class="flex flex-row justify-between">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'vertical',
      validator: (value) => ['vertical', 'horizontal'].includes(value),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showGradient: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
    captionSize: {
      type: String,
      default: 'large',
    },
    link: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    isHorizontal() {
      return this.type === 'horizontal'
    },
    isVertical() {
      return this.type === 'vertical'
    },
    hasTitle() {
      return !!this.title
    },
    hasCaption() {
      return !!this.caption
    },
  },
  methods: {
    hasSlot(name) {
      return !!this.$slots[name]
    },
  },
}
</script>
